__turbopack_context__.v({
  "art": "album-loader-module__fyYnAq__art",
  "back": "album-loader-module__fyYnAq__back",
  "breathe-shadow": "album-loader-module__fyYnAq__breathe-shadow",
  "fan-back": "album-loader-module__fyYnAq__fan-back",
  "fan-middle": "album-loader-module__fyYnAq__fan-middle",
  "float-front": "album-loader-module__fyYnAq__float-front",
  "front": "album-loader-module__fyYnAq__front",
  "label": "album-loader-module__fyYnAq__label",
  "loader": "album-loader-module__fyYnAq__loader",
  "middle": "album-loader-module__fyYnAq__middle",
  "shadow": "album-loader-module__fyYnAq__shadow",
});
